import { setTimeout as delay } from "node:timers/promises";
import {
  acquireLock,
  isWakeLoopLockError,
  runWithHeldLock,
} from "../../config/lock";

const OPENCLAW_BOOTSTRAP_LOCK_KEY = "openclaw-bootstrap";
const OPENCLAW_BOOTSTRAP_LOCK_RETRY_DELAY_MS = 100;
const OPENCLAW_BOOTSTRAP_LOCK_TIMEOUT_MS = 5000;

export async function withOpenClawBootstrapLock<T>(input: {
  wakeLoopProfileId: string;
  run: () => Promise<T>;
}): Promise<T> {
  const startedAtMs = Date.now();

  for (;;) {
    try {
      const lock = await acquireLock({
        wakeLoopProfileId: input.wakeLoopProfileId,
        key: OPENCLAW_BOOTSTRAP_LOCK_KEY,
        meta: {
          component: "openclaw.bootstrap",
          wakeLoopProfileId: input.wakeLoopProfileId,
        },
      });
      return await runWithHeldLock({
        lock,
        run: input.run,
        releaseContext: {
          component: "openclaw.bootstrap",
          lockKey: OPENCLAW_BOOTSTRAP_LOCK_KEY,
          wakeLoopProfileId: input.wakeLoopProfileId,
        },
      });
    } catch (error) {
      if (
        !isWakeLoopLockError(error) ||
        Date.now() - startedAtMs >= OPENCLAW_BOOTSTRAP_LOCK_TIMEOUT_MS
      ) {
        throw error;
      }
      await delay(OPENCLAW_BOOTSTRAP_LOCK_RETRY_DELAY_MS);
    }
  }
}
